import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { SessionExpiredDialog } from "../components/session-expired-dialog";
import { VirtualPageView } from "../components/virtual-page-view";
import { PostHogUserIdentifier } from "../containers/posthog-user-identifier";
import type { QueryClient } from "@tanstack/react-query";

interface MyRouterContext {
  queryClient: QueryClient;
}

const RootComponent = () => (
  <>
    <VirtualPageView />
    <PostHogUserIdentifier />
    <SessionExpiredDialog />
    <Outlet />
  </>
);

export const rootRoute = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
});
